import { useEffect } from "react";
import $ from "jquery";

const useQueryReloadButton = (isLoading, isRefetching, refetch) => {
  useEffect(() => {
    if (!isLoading || !isRefetching) {
      const $pagerLast = $(".k-pager-last");
      const $existingReloadBtn = $pagerLast.next("#reloadBtn");
      if ($pagerLast.length > 0 && $existingReloadBtn.length === 0) {
        $(
          "<span id='reloadBtn' class='k-i-refresh k-icon ml-3 cursor-pointer'></span>"
        ).insertAfter($pagerLast);
      }
      const reloadButton = document.getElementById("reloadBtn");
      const reloadHandler = () => {
        reloadButton.style.animation = "k-loading-animation 1s linear infinite";
        refetch().finally(() => {
          reloadButton.style.animation = "";
        });
      };

      if (reloadButton) reloadButton.addEventListener("click", reloadHandler);

      return () => {
        if (reloadButton)
          reloadButton.removeEventListener("click", reloadHandler);
      };
    }
  }, [isLoading, isRefetching, refetch]);
};

export default useQueryReloadButton;
